// 库存转移
export default [ //转库单
  {
    path: '/transferOrder',
    name: 'transferOrder',
    component: () => import( /* webpackChunkName: "warehouse" */ '@/views/home/inventoryTransfer/transferOrder'),
    meta: {
      activeMenu: 'transferOrder', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  // 转库箱子列表
  {
    path: '/transferBox',
    name: 'transferBox',
    component: () => import( /* webpackChunkName: "warehouse" */ '@/views/home/inventoryTransfer/transferBox'),
    meta: {
      activeMenu: 'transferBox', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  }
]